import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdSearch } from "react-icons/md";
import { FaRobot } from "react-icons/fa";
import useAxiosInstance from "../../hooks/useAxios.jsx";

const CustomAgentsOrgSelect = () => {
  const navigate = useNavigate();
  const axios = useAxiosInstance();
  const [orgs, setOrgs] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    axios
      .get(`admin/organisations/`, {
        params: { org_type: "all", activity_status: "" },
      })
      .then((res) => {
        const data = res.data;
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
          ? data.results
          : Array.isArray(data?.organisations)
          ? data.organisations
          : [];
        setOrgs(list);
      })
      .catch(() => {});
  }, []);

  const filtered = orgs.filter((o) =>
    (o.name || o.org_name || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6">
      <div className="text-2xl font-semibold flex items-center gap-2 mb-6">
        <FaRobot />
        Custom Agents
      </div>

      <div className="max-w-lg">
        <p className="text-sm font-medium mb-2">Select an organisation</p>
        <div className="relative mb-3">
          <MdSearch className="absolute left-3 top-2.5 text-gray-400" />
          <input
            className="w-full border rounded-lg px-9 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-gray-400"
            placeholder="Search organisations..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </div>

        <div className="border bg-white rounded-lg overflow-hidden max-h-[70vh] overflow-y-auto">
          {filtered.length === 0 && (
            <p className="text-xs text-gray-400 p-4">No organisations found.</p>
          )}
          {filtered.map((org) => {
            const id = org.id || org.pk;
            const name = org.name || org.org_name || `Org #${id}`;
            return (
              <div
                key={id}
                onClick={() => navigate(`/custom-agents/${id}`, { state: { orgName: name } })}
                className="px-4 py-3 text-sm border-b cursor-pointer hover:bg-slate-50 last:border-b-0"
              >
                {name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CustomAgentsOrgSelect;
